import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Meta, PageTitle } from './Typography'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: ReactNode
  /** 'dark' sits the title/description on a dark canvas (e.g. the
   * Dashboard's glow background) instead of the default light page canvas
   * every other page uses. */
  variant?: 'light' | 'dark'
}

export function PageHeader({ title, description, actions, variant = 'light' }: PageHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"
    >
      <div>
        <PageTitle className="text-canvas-fg">{title}</PageTitle>
        {description && (
          <Meta className={cn('mt-1 text-sm font-normal', variant === 'dark' ? 'text-canvas-fg/60' : 'text-canvas-fg/70')}>
            {description}
          </Meta>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </motion.div>
  )
}
